import React, { useEffect, useState } from 'react'
import { Badge, Button, Checkbox, Col, DatePicker, Empty, Form, Input, Modal, Row, Select, Space, Table } from 'antd'
import { ArrowDown2, ArrowLeft2, ArrowRight2, Calendar, SearchNormal1 } from 'iconsax-react'
import Column from 'antd/es/table/Column'
import { useTranslation } from 'react-i18next'
import { PATH_FRONT } from '../../routes/path'
import { Link, useNavigate } from 'react-router-dom'
import SupportStatusChangeModal from '../modals/SupportStatusChangeModal'
import http from '../../../security/Http'
import moment from 'moment'
import { Spin } from 'antd';
import { format} from 'date-fns';
import { ja } from 'date-fns/locale';
import Highlighter from "react-highlight-words";
import Loader from '../../Loader'
import url from '../../../Development.json'
import  authStore  from '../../contexs/AuthProvider'
import { formatShiftSectionTitle, getShiftStartDay } from '../../utils/businessDay'
import 'moment/locale/ja';

const { Option } = Select;
const { TextArea } = Input;

function getTwilioPageToken(pageUrl) {
  if (!pageUrl) return '';
  try {
    return new URL(pageUrl).searchParams.get('PageToken') || '';
  } catch {
    try {
      const query = pageUrl.includes('?') ? pageUrl.split('?').pop() : pageUrl;
      return new URLSearchParams(query).get('PageToken') || '';
    } catch {
      return '';
    }
  }
}

function Dashboard() {
  const { t, i18n } = useTranslation();
  const [supportStatusChangeModalOpen, setSupportStatusChangeModalOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagetoken, setpagetoken] = useState("");
  const [callhistory, setCallhistory] = useState([])
  const [shiftResponder, setShiftResponder] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [iscallLoading, setIscallLoading] = useState(true)
  const [isreportLoading, setIsreportLoading] = useState(true)
  const [isrespondtLoading, setIsrespondtLoading] = useState(true)
  const navigate = useNavigate();
  const authstore = authStore()


  var Token = authstore?.accessToken || localStorage.getItem('token');
  // console.log(Token,"accesstoken");
  // const Token = localStorage.getItem('token')
  const lang = localStorage.getItem('i18nextLng')

  const [prebutton, setPrebutton] = useState("");
  const [nextButton, setNextButton] = useState("");
  const [prePageToken, setprePageToken] = useState("");
  const [nextPageToken, setNextPageToken] = useState("");
  const [search, setSearch] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const [reportcurrentPage, setreportCurrentPage] = useState(1);
  const [report, setReport] = useState([])
  const [reporttotal, setreportTotal] = useState("");
  const [reportprebutton, setreportPrebutton] = useState(0);
  const [reportnextButton, setreportNextButton] = useState(true);

  const [missedcall, setMissedcall] = useState([])
  const [missedcurrentPage, setMissedCurrentPage] = useState(1);
  const [missednextButton, setMissedNextButton] = useState("");
  const [missedprebutton, setMissedPrebutton] = useState("");
  const [missedpagetoken, setMissedpagetoken] = useState("");
  const [missedprePageToken, setMissedprePageToken] = useState("");

  var shiftSectionTitle = formatShiftSectionTitle(lang);
  var today = getShiftStartDay();
  const handlePagination = (increment) => {
    if (nextButton == undefined) {
      return false;
    } else {
      setCurrentPage((prevPage) => prevPage + increment);
    }
  };
  const handleperviousPagination = (increment) => {
    // console.log(prePageToken);
    // console.log(prebutton, "prebutton");
    if (prebutton == undefined) {
      return false;
    } else {
      setpagetoken(prePageToken);
      setCurrentPage(currentPage + increment);
      // console.log(currentPage,"currentPage");
    }
  };


  const missedhandlePagination = (increment) => {
    if (missednextButton == undefined) {
      return false;
    } else {
      setMissedCurrentPage((prevPage) => prevPage + increment);
    }
  };
  const missedhandleperviousPagination = (increment) => {
    // console.log("onclick");
    // console.log(missedprePageToken);
    // console.log(missedprebutton, "prebutton");
    if (missedprebutton == undefined || "") {
      return false;
    } else {
      setMissedpagetoken(missedprePageToken);
      setMissedCurrentPage(missedcurrentPage + increment);
      // console.log(currentPage,"currentPage");
    }
  };
  const getoneuser = (report) => {
    navigate("/staff-details", { state: report });
  }

  const callhistorys = () => {
    if (!Token) return;
    http.get(process.env.REACT_APP_BASE_URL + `/admin/callHistory?page=${currentPage}&&pageToken=${pagetoken}`, [], {
      headers: { 'authorization': 'Bearer ' + Token, lang: lang }
    })
      .then((res) => {
        setIscallLoading(false);
        const pageData = res?.data?.data || {};
        setCallhistory(Array.isArray(pageData.instances) ? pageData.instances : []);
        setNextButton(pageData.nextPageUrl);
        setPrebutton(pageData.previousPageUrl);
        setpagetoken(getTwilioPageToken(pageData.nextPageUrl));
        setprePageToken(getTwilioPageToken(pageData.previousPageUrl));
      })
      .catch(() => {
        setIscallLoading(false);
      })
  }
  const getShiftResponder = () => {
    if (!Token) return;
    http.get(process.env.REACT_APP_BASE_URL + `/admin/responderShift?page=${1}&&startDay=${today}`, [], {
      headers: { 'authorization': 'Bearer ' + Token, lang: lang }
    })
      .then((res) => {
        // console.log(res?.data,"Responder");
        // console.log(res?.data,"resssssssssssssssss");
        setShiftResponder(res?.data)
        setIsrespondtLoading(false);
      })
      .catch(() => {
        setIsrespondtLoading(false);
      })
  }

  
  const getreportdetails = (report) => {
    navigate("/report-details ", { state: report });
  }
  const getonefacility = (report) => {
    const data ={
      report:report,
      Token:Token
    }
    navigate("/facility-details", { state: data });
  }
  const  nameselectedrespont = (n) => {
    navigate("/staff-details", { state: n });
  }

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return lang == 'en' ? format(d, 'yyyy-MMM-d h:mm a') : format(d, "yyyy'年'MMMd'日'ah:mm", { locale: ja });
  };

  // SP向けの短い日時（例: 8/20 (水) 07:37）
  const formatCompactDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return lang == 'en'
      ? format(d, 'M/d (EEE) HH:mm')
      : format(d, 'M/d (E) HH:mm', { locale: ja });
  };

  const getCompactStatusBadge = (status) => {
    const map = lang === 'en'
      ? { 0: 'Unconfirmed', 1: 'In Prep', 2: 'Done' }
      : { 0: '未確認', 1: '準備中', 2: '完了' };
    const colors = {
      0: { backgroundColor: '#f2dbcb', color: '#7a4a2b' },
      1: { backgroundColor: '#cce6f2', color: '#1f5f7a' },
      2: { backgroundColor: '#ccf2d6', color: '#1f6b3a' },
    };
    if (map[status] == null) return null;
    return (
      <span className="mobile-compact-badge is-status" style={colors[status]}>
        {map[status]}
      </span>
    );
  };

  const handlereportPagination = (increment) => {
    if (!reportprebutton) {
      return false;
    } else {
      setreportCurrentPage((prevPage) => prevPage + increment);
    }
  };
  const handlereportperviousPagination = (increment) => {
    if (reportnextButton <= 1) {
      return false;
    } else {
      setreportCurrentPage(reportcurrentPage - increment);
    }
  };
  const getreport = () => {
    if (!Token) return;
    http.get(process.env.REACT_APP_BASE_URL + `/admin/getReport?page=${reportcurrentPage}&limit=5`, [], {
      headers: { 'authorization': 'Bearer ' + Token, lang: lang }
    })
      .then((res) => {
        setIsreportLoading(false);
        // console.log(res.data[0].data);
        setReport(res.data[0].data)
        setreportTotal(res.data[0].metadata[0].total)
        setreportPrebutton(res.data[0].metadata[0].hasMoreData)
        setreportNextButton(res.data[0].metadata[0].page)
      })
      .catch(() => {
        setIsreportLoading(false);
      })

  }
  function setFilter(e){
    setSearch(e.target.value);
}


  const getmissedcall = () => {
    if (!Token) return;
    http.get(process.env.REACT_APP_BASE_URL + `/admin/missedCallHistory?page=${missedcurrentPage}&&pageToken=${missedpagetoken}&&search=${search}`, [], {
      headers: { 'authorization': 'Bearer ' + Token, lang: lang }
    })

      .then((res) => {
        setIsLoading(false);
        const pageData = res?.data?.data || {};
        setMissedcall(Array.isArray(pageData.instances) ? pageData.instances : []);
        setMissedNextButton(pageData.nextPageUrl);
        setMissedPrebutton(pageData.previousPageUrl);
        setMissedpagetoken(getTwilioPageToken(pageData.nextPageUrl));
        setMissedprePageToken(getTwilioPageToken(pageData.previousPageUrl));
      })
      .catch(() => {
        setIsLoading(false);
      })

  }

  const deleterecord = (e) => {
    // console.log(e,"eeeeeee");
    const sid = e?.sid 
    http.callApi(url.deletemisscall, {sid}, {
      headers: { 'authorization': 'Bearer ' + Token, lang: lang }
    })
      .then((res) => {
        // console.log(res?.data, "res delete");
        // setPlan(res?.data);
        //setIsLoading(true);
        let updatedMissedcall = missedcall.filter((item) => item.sid !== sid);
        setMissedcall(updatedMissedcall)
      })
      .catch((errors) => {
        console.log(errors?.response)
      }
      )
  } 





  useEffect(() => {
    if (!Token) return;
    getmissedcall()
  }, [missedcurrentPage, Token])
  useEffect(() => {
    if (!Token) return;
    getreport()
  }, [reportcurrentPage, Token])

  useEffect(() => {
    if (!Token) return;
    callhistorys()
  }, [currentPage, Token])

  useEffect(() => {
    if (!Token) return;
    getShiftResponder()
  }, [Token])





  let getStatusText

  lang == "en" ?
    getStatusText = (status) => {
      switch (status) {
        case 0:
          return <span style={{ backgroundColor: "#f2dbcb", padding: "3px 13px", borderRadius: "5px", width: "100px" }}>Unconfirmed</span>;
        case 1:
          return <span style={{ backgroundColor: "#cce6f2", padding: "3px 10px", borderRadius: "5px" }}>In Preparation</span>;
        case 2:
          return <span style={{ backgroundColor: "#ccf2d6", padding: "3px 20px", borderRadius: "5px" }}>Completed</span>;
        default:
          return null;
      }
    } :
    getStatusText = (status) => {
      switch (status) {
        case 0:
          return <span style={{ backgroundColor: "#f2dbcb", padding: "3px 13px", borderRadius: "5px", width: "100px" }}>未確認</span>;
        case 1:
          return <span style={{ backgroundColor: "#cce6f2", padding: "3px 10px", borderRadius: "5px" }}>準備中</span>;
        case 2:
          return <span style={{ backgroundColor: "#ccf2d6", padding: "3px 20px", borderRadius: "5px" }}>完了</span>;
        default:
          return null;
      }
    }

  const start = () => {
    setLoading(true);
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
  
    <section className='ptb40'>
    
      <div className="fliter_box_card mb30">
    
        {/* <Form>
          <Space className='flex-wrap flex_item_ce'>
            <Form.Item className='mb0'>
              <Input onChange={setFilter} placeholder={t('table_title.No_Facility_Name_Yomi')} prefix={<SearchNormal1 size={18} color="#707070" variant="Outline" />} />
            </Form.Item>
            <Form.Item className='mb0'>
              <Button onClick={getmissedcall} type="primary" className='btn-theme btn-warning btn-with-icon' icon={<ArrowRight2 size={24} color="#ffffff" variant="Bold" />}>{t('dashboard.Search')}</Button>
            </Form.Item>
          </Space>
        </Form> */}
      </div>
      <div className="custom_card mb30">
     
      </div>
      <div className="custom_card mb30">
        <div className="custom_card_head flex_item_cb flex-wrap mb10">
          <h4>{t('table_title.Incoming_call_history')}</h4>
          <div className="pagination_flex flex_item_cc">
            <a role='button' onClick={() => prebutton ? handleperviousPagination(-1) : ""} className={`flex_item_cc prev_btn gap1 ${prebutton === 0 ? 'disabled' : ''}`} disabled={prebutton === 0}><ArrowLeft2 size={24} color="#0D0B0B" variant="Bold" /> {t('table_title.Previous')}</a>
            <a role='button' onClick={() => nextButton ? handlePagination(1) : ""} disabled={!nextButton} className={`flex_item_cc next_btn gap1 ${nextButton ? '' : 'disabled'}`} >{t('table_title.Next')}<ArrowRight2 size={24} color="#0D0B0B" variant="Bold" /></a>
          </div>
        </div>
        <div className="custom_card_body">
          <div className="custom_table_wrapper">
          {iscallLoading == true ?    <Loader /> : <>
            {isMobile ? (
              callhistory?.length ? (
                <div className="mobile-compact-list">
                  {callhistory.map((e, idx) => (
                    <div key={e?.sid || idx} className="mobile-compact-item">
                      <div className="mobile-compact-left">
                        <div className="mobile-compact-date">{formatCompactDateTime(e?.dateCreated)}</div>
                        <span className="mobile-compact-badge">{lang === 'en' ? 'Handled' : '対応済み'}</span>
                      </div>
                      <div className="mobile-compact-main">
                        <a
                          className="mobile-compact-name"
                          style={{ color: "#0638be" }}
                          onClick={() => getoneuser(e)}
                        >
                          {e?.respondent_data?.name || '-'}
                        </a>
                        <a
                          className="mobile-compact-sub"
                          onClick={() => getonefacility(e)}
                        >
                          {e?.facility_data?.name || '-'}
                        </a>
                      </div>

                    </div>
                  ))}
                </div>
              ) : (
                <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            ) : (
              <Table scroll={{ x: 900 }} className='text-nowrap' pagination={false} dataSource={callhistory} locale={{emptyText : <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />}}>
                <Column ellipsis={true} title={t('table_title.Corresponding_Person')} dataIndex={"from"} key={"responders"}
                  render={(_, e) => <a style={{ color: "#0638be" }} onClick={() => getoneuser(e)} to={""}>{e?.respondent_data?.name}</a>}
                  className='td_responders text-start' ></Column>
                <Column ellipsis={true} title={t('table_title.Name_of_facility')} dataIndex={"to"} key={"facilityName"}
                  render={(_, e) => <a style={{ color: "#0638be" }} onClick={() => getonefacility(e)} to={""}>{e?.facility_data?.name}</a>}
                  className='td_facility_name' format={"DD-MM-YYYY"} ></Column>
                <Column ellipsis={true} title={t('table_title.Date')} dataIndex={"dateCreated"} key={"day"} className='td_day'
                  render={(text) => {
                   var tDate = text;
                   return lang == 'en' ? format(new Date(tDate), 'yyyy-MMM-d h:mm a') : format(new Date(tDate), "yyyy'年'MMMd'日'ah:mm", { locale: ja })
                  }}
                ></Column>
              </Table>
            )}
          </>}
          </div>
        </div>
      </div>
      <div className="custom_card mb30">
        <div className="custom_card_head flex_item_cb flex-wrap mb10">
          <h4>{t('table_title.Missed_Calls')}</h4>
          <div className="pagination_flex flex_item_cc">
            <a role='button' onClick={() => missedprebutton ? missedhandleperviousPagination(-1) : ""} className={`flex_item_cc prev_btn gap1 ${missedprebutton === 0 ? 'disabled' : ''}`} ><ArrowLeft2 size={24} color="#0D0B0B" variant="Bold" /> {t('table_title.Previous')}</a>
            <a role='button' onClick={() => missednextButton ? missedhandlePagination(1) : ""} disabled={!missednextButton} className={`flex_item_cc next_btn gap1 ${missednextButton ? '' : 'disabled'}`} >{t('table_title.Next')}<ArrowRight2 size={24} color="#0D0B0B" variant="Bold" /></a>
          </div>
        </div>
        <div className="custom_card_body">
          <div className="custom_table_wrapper">
              {isLoading == true ?    <Loader /> : <>
                {isMobile ? (
                  missedcall?.length ? (
                    <div className="mobile-compact-list">
                      {missedcall.map((e, idx) => (
                        <div key={e?.sid || idx} className="mobile-compact-item">
                          <div className="mobile-compact-left">
                            <div className="mobile-compact-date">{formatCompactDateTime(e?.dateCreated)}</div>
                            <span className="mobile-compact-badge is-missed">{lang === 'en' ? 'Missed' : '不在'}</span>
                          </div>
                          <div className="mobile-compact-main">
                            <a
                              className="mobile-compact-name"
                              style={{ color: "#ed1111" }}
                              onClick={() => getonefacility(e)}
                            >
                              <Highlighter
                                highlightClassName="YourHighlightClass"
                                searchWords={[search]}
                                autoEscape={true}
                                textToHighlight={e?.facility_data?.name || '-'}
                              />
                            </a>
                          </div>
                          <div className="mobile-compact-right">
                            <Button onClick={() => deleterecord(e)} className="btn-theme btn-sm btn-danger">
                              {t('table_title.Delete')}
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )
                ) : (
                  <Table className='text-nowrap' pagination={false} dataSource={missedcall} locale={{emptyText : <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />}}>
                    <Column title={t('table_title.Name_of_facility')} dataIndex={"facilityName"}
                      render={(_, e) => <a style={{ color: "#ed1111" }} onClick={() => getonefacility(e)} to={""}>
                        <Highlighter
                        highlightClassName="YourHighlightClass"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={e?.facility_data?.name}
                      />
                      </a>}
                      key={"facilityName"} className='td_facility_name' ></Column>
                    <Column title={t('table_title.Date')} dataIndex={"day"}
                      render={(_, e) => {
                        var contractStartDate = e?.dateCreated;
                        let dt="";
                        if(contractStartDate){
                          dt = lang == 'en' ? format(new Date(contractStartDate), "yyyy-MMM-d h:mm a") : format(new Date(contractStartDate), "yyyy'年'MMMd'日'ah:mm", { locale: ja })
                        }
                        return(
                        <Highlighter
                          highlightClassName="YourHighlightClass"
                          searchWords={[search]}
                          autoEscape={true}
                          textToHighlight={dt}
                        />
                        )
                      }}
                      key={"day"} className='td_day'></Column>
                    <Column title={t('table_title.Button')} dataIndex={"time"} key={"time"} className='td_time'
                      render={(_,e) => (
                        <Button onClick={()=>deleterecord(e)} className="btn-theme btn-sm btn-with-icon btn-danger" style={{ marginLeft: "auto" }}>
                          {t('table_title.Delete')}
                        </Button>
                      )} >
                    </Column>
                  </Table>
                )}
              </>}
          </div>
        </div>
      </div>
      <div className="custom_card mb30">
        <div className="custom_card_head flex_item_cb flex-wrap mb10">
          <h4>{t('table_title.Report_List')}</h4>
          <div className="pagination_flex flex_item_cc">
            <a role='button' onClick={() => reportnextButton > 1 ? handlereportperviousPagination(1) : ""} className={`flex_item_cc prev_btn gap1 ${reportnextButton <= 1 ? 'disabled' : ''}`} disabled={reportnextButton <= 1}><ArrowLeft2 size={24} color="#0D0B0B" variant="Bold" /> {t('table_title.Previous')}</a>
            <a role='button' onClick={() => reportprebutton ? handlereportPagination(1) : ""} disabled={!reportprebutton} className={`flex_item_cc next_btn gap1 ${reportprebutton ? '' : 'disabled'}`} >{t('table_title.Next')}<ArrowRight2 size={24} color="#0D0B0B" variant="Bold" /></a>
          </div>
        </div>
        <div className="custom_card_body">
          <div className="custom_table_wrapper">
          {isreportLoading == true ?    <Loader /> : <>
            {isMobile ? (
              report?.length ? (
                <div className="mobile-compact-list">
                  {report.map((e, idx) => (
                    <div key={e?._id || e?.id || idx} className="mobile-compact-item">
                      <div className="mobile-compact-left">
                        <div className="mobile-compact-date">{formatCompactDateTime(e?.createdAt)}</div>
                        <a onClick={() => getreportdetails(e)}>
                          {getCompactStatusBadge(e?.status)}
                        </a>
                        {e?.reportType == 1 ? (
                          <span className="mobile-compact-badge is-missed">
                            {lang === 'en' ? 'First Aid' : '救急搬送'}
                          </span>
                        ) : null}
                      </div>
                      <div className="mobile-compact-main">
                        <a
                          className="mobile-compact-name"
                          style={{ color: "#0638be" }}
                          onClick={() => getoneuser(e)}
                        >
                          {e?.respondent_data?.name || '-'}
                        </a>
                        <a
                          className="mobile-compact-sub"
                          onClick={() => getonefacility(e)}
                        >
                          {e?.facility_data?.name || '-'}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            ) : (
              <Table scroll={{ x: 900 }} className='text-nowrap' pagination={false} dataSource={report} locale={{emptyText : <Empty description={<p>{t('Reports.No_Data')}</p>} image={Empty.PRESENTED_IMAGE_SIMPLE} />}}>
                <Column title={t('table_title.Status')} dataIndex={"status"} key={"status"}
                  render={(_, e) => <a onClick={() => getreportdetails(e)} to={""}>{getStatusText(e.status)}</a>} className='td_status text-start' ></Column>
                <Column title={t('table_title.FirstAid')} dataIndex={"reportType"} key={"reportType"} className='td_time text-start'
                  render={(e) => (
                    lang === "en" ? (e == 1 ? <p><span style={{ color: "red" }}>First Aid</span></p> : "") : (e === 1 ? <p><span style={{ color: "red" }}>救急搬送</span></p> : null)
                  )}
                ></Column>
                <Column ellipsis={true} title={t('table_title.Corresponding_Person')} dataIndex={"staffId"} key={"responders"}
                  render={(_, e) => <a style={{ color: "#0638be" }} onClick={() => getoneuser(e)} to={""}>{e?.respondent_data?.name}</a>}
                  className='td_responders text-start' ></Column>
                <Column ellipsis={true} title={t('table_title.Name_of_facility')} dataIndex={["facility_data", "name"]} key={"facilityName"}
                  render={(_, e) => <a style={{ color: "#0638be" }} onClick={() => getonefacility(e)} to={""}>{e?.facility_data?.name}</a>}
                  className='td_facility_name' ></Column>
                <Column ellipsis={true} title={t('table_title.Date')} dataIndex={"createdAt"} key={"day"} className='td_day'
                  render={(text) => {
                    var tDate = text;
                   return lang == 'en' ? format(new Date(tDate), 'yyyy-MMM-d h:mm a') : format(new Date(tDate), "yyyy'年'MMMd'日'ah:mm", { locale: ja })
                    
                  }}
                ></Column>
                {/* <Column title={t('table_title.Action')} dataIndex={"action"} key={"action"} className='td_action' ></Column> */}
              </Table>
            )}
          </>}
          </div>
        </div>
      </div>
      <div className="custom_card">
        <div className="custom_card_head flex_item_cb flex-wrap mb10">
          {/* <h4>{t('table_title.March_20_2023_shift')}</h4> */}
          <h4>{shiftSectionTitle}</h4>
          <p> {t('table_title.It_will_be_updated_at_13_00_PM_the_next_day')}</p>
        </div>
        <div className="custom_card_body p0" style={{ border: "none" }}>
          <div className="custom_table_wrapper leader_and_responder_table">
            {/* <Table showHeader={false} scroll={{ x: 900 }} defaultExpandAllRows={true} showExpandColumn={false} className='text-nowrap' pagination={false} dataSource={shiftResponder}> */}
            {/* <Column title={t('table_title.Responder')} dataIndex={"shiftTime"} key={"shiftTime"}
                render={(_, data) => data?.shiftName[0] + " : " + data?.shift_data[0].startTime + " ~ " + data?.shift_data[0].endTime}
                className='td_responders text-start' ></Column>
              <Column
                title={t('table_title.Responder')}
                render={(_, data) => (
                  <div className="name-wrapper">
                    {data?.name.length > 1 && <span className="name-padding" />}
                    {data?.name.map((name, index) => (
                      <span key={index} className="name" style={{margin:"0 5px"}}>
                        {name}
                      </span>
                    ))}
                    {data?.name.length > 1 && <span className="name-padding" />}
                  </div>
                )}
                dataIndex="responders1"
                key="responders1"
                className="td_responders text-start"
              ></Column> */}
            {/* <Column title={t('table_title.Responder')} dataIndex={"responders2"} key={"responders2"} className='td_responders' ></Column>
              <Column title={t('table_title.Responder')} dataIndex={"responders3"} key={"responders3"} className='td_responders' ></Column>
              <Column title={t('table_title.Responder')} dataIndex={"responders4"} key={"responders4"} className='td_responders'></Column> */}
            {/* </Table> */}
          </div>
          <div className="leader_and_responder_table shift_badge_list">
          {
            shiftResponder.length ==0 ? 
            <div className=" responder_item border_card mb16">
              <div class="css-dev-only-do-not-override-w8mnev ant-empty ant-empty-normal" ><div class="ant-empty-image"><svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1)" fill="none" fill-rule="evenodd"><ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse><g fill-rule="nonzero" stroke="#d9d9d9"><path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path><path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path></g></g></svg></div><div class="ant-empty-description">{t('Reports.No_Data')}</div></div>
              </div>: 
                  shiftResponder.map((r) => {
                    {/* const badgeClass = `shift_badge mb10 badge_${r?.shiftName[0] === 'A' ? 'primary' : r?.shiftName[0] === 'B' ? 'success' : r?.shiftName[0] === 'C' ? 'warning' : r?.shiftName[0] === 'D' ? 'danger' : 'default'}`; */}
                    const badgeClass = `shift_badge mb10 badge_${r?.shiftName === 'A' ? 'primary' : r?.shiftName === 'B' ? 'success' : r?.shiftName === 'C' ? 'warning' : r?.shiftName === 'D' ? 'danger' : 'default'}`;

                    return (
                      <div className="responder_item border_card mb16">
                        <span className={badgeClass}>{r?.shiftName} : {r?.shift_data?.startTime} ~ {r?.shift_data?.endTime}</span>
                        <ul className="responder_list">
                        
                          {r?.shift_staff_data?.map((n) => {
                            if (n === "") {
                              return <li>Data Not Found</li>;
                            }
                            return (
                              <li>
                                <a onClick={()=> n?.name=="-" ? "": nameselectedrespont(n)}  className=" fw-600 fs-16 mb10" to={ n?.name=="-" ?"": PATH_FRONT.staffDetails}>
                                  {n?.name}
                                </a>
                              </li>
                            );
                          })}
                        </ul>

                        {/* <ul className="responder_list">
                          {r?.shift_staff_data?.map((n) => {
                            if (n === "") {
                              return <li>Data Not Found</li>;
                            }
                            return (
                              <li>
                                <a  onClick={()=> nameselectedrespont(n)}  className=" fw-600 fs-16" to={PATH_FRONT.staffDetails}>
                                  {n?.name}
                                </a>
                              </li>
                            );
                          })}
                        </ul> */}
                      </div>
                    );
                  })
                }

   
                 
       
     
             
           
      {/* <div className="responder_item border_card mb16">
              <span className='shift_badge mb10 badge_success'>B : 20:00〜0:00</span>
              <h6 className='text-danger fs-16 mb10'>{t('table_title.Leader')}</h6>
              <ul className='responder_list'>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} A</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} B</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} C</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} D</Link></li>
              </ul>
            </div>
            <div className="responder_item border_card mb16">
              <span className='shift_badge mb10 badge_warning'>C : 0:00〜6:00</span>
              <h6 className='text-danger fs-16 mb10'>{t('table_title.Leader')}</h6>
              <ul className='responder_list'>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} A</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} B</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} C</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} D</Link></li>
              </ul>
            </div>
            <div className="responder_item border_card mb16">
              <span className='shift_badge mb10 badge_danger'>D : 6:00〜8:30</span>
              <h6 className='text-danger fs-16 mb10'>{t('table_title.Leader')}</h6>
              <ul className='responder_list'>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} A</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} B</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} C</Link></li>
                <li><Link className="fw-600 fs-16" to={PATH_FRONT.staffDetails}>{t('table_title.Responder')} D</Link></li>
              </ul>
            </div> */}
    </div>
        </div >
      </div >
    <SupportStatusChangeModal modalOpenEvent={supportStatusChangeModalOpen} modalCloseEvent={setSupportStatusChangeModalOpen} />
    </section >
  )
}

export default Dashboard
